import { Controller } from "@hotwired/stimulus"

// Counts down the storefront checkout hold (mm:ss) from the server-provided
// expiry epoch. Display-only progressive enhancement — the server re-verifies
// the hold on every checkout step, so this timer never gates anything; it just
// tells the renter how long their unit is theirs.
export default class extends Controller {
  static values = { expiresAt: Number }
  static targets = ["display"]

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const remaining = Math.max(0, Math.floor(this.expiresAtValue - Date.now() / 1000))
    const minutes = Math.floor(remaining / 60)
    const seconds = String(remaining % 60).padStart(2, "0")
    if (this.hasDisplayTarget) this.displayTarget.textContent = `${minutes}:${seconds}`
  }
}
